import { faker } from '@faker-js/faker';
import { HttpResponse, delay, http } from 'msw';

export const getPostApiJsApPayeesInvitationsPdfsMock = () => ({
  id: faker.string.uuid(),
  message: 'PDF successfully generated',
  redirect_url: faker.internet.url(),
});

export const getGetApPayeeContactInformTemplateMock = () => ({
  default_template: {
    body: faker.word.sample(),
    subject: faker.word.sample(),
  },
  saved_template: {
    body: faker.word.sample(),
    subject: faker.word.sample(),
  },
});

faker.seed(123);

export const handlers = [
  http.post('*/api/js/ap_payees/invitations/pdfs', async () => {
    await delay(800);
    return new HttpResponse(
      JSON.stringify(getPostApiJsApPayeesInvitationsPdfsMock()),
      {
        status: 200,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }),
  http.get('*/api/js/ap_payee_contact_inform_template', async () => {
    await delay(1000);
    return new HttpResponse(
      JSON.stringify(getGetApPayeeContactInformTemplateMock()),
      {
        status: 200,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }),
];
